import React, { useMemo, useState } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Pagination } from '../components/ui/Pagination';
import { ActionsTable } from '../components/operations/ActionsTable';
import { actionsStore, sortActions } from '../services/actionsStore';
import { Search, Filter, Download } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { usePagination } from '../hooks/usePagination';
export function ActionsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [assigneeFilter, setAssigneeFilter] = useState('all');
  const [refresh, setRefresh] = useState(0);
  const allActions = useMemo(() => actionsStore.getAll(), [refresh]);
  const filteredActions = useMemo(() => {
    let result = allActions;
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      result = result.filter(a => a.name.toLowerCase().includes(lowerSearch) || a.clientName.toLowerCase().includes(lowerSearch) || a.activityProduct.toLowerCase().includes(lowerSearch));
    }
    if (statusFilter !== 'all') {
      const isDone = statusFilter === 'done';
      result = result.filter(a => a.isDone === isDone);
    }
    if (assigneeFilter !== 'all') {
      result = result.filter(a => a.assigneeType === assigneeFilter);
    }
    return sortActions(result);
  }, [allActions, searchTerm, statusFilter, assigneeFilter]);
  const {
    currentPage,
    totalPages,
    paginatedData: currentActions,
    goToPage
  } = usePagination(filteredActions, 30);
  const handleActionUpdate = () => {
    setRefresh(r => r + 1);
  };
  return <Layout data-id="element-2343" data-mp="2fp68wapugfig">
      <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2344" data-mp="2fppj15995zlx">
        <div data-id="element-2345" data-mp="2knhiqlg52q0o">
          <h1 className="text-2xl font-bold text-seform-navy" data-id="element-2346" data-mp="2kp24blkh6yme">Azioni</h1>
          <p className="text-slate-500 mt-1" data-id="element-2347" data-mp="2cn1j3jy3jd33">
            Gestione di tutte le azioni operative
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-2348" data-mp="28mrdi8e7uoor">
          <Button variant="flat" startContent={<Download className="h-4 w-4" data-id="element-2350" data-mp="2mi388fsdgf5o" />} data-id="element-2349" data-mp="2mkppj752e913">
            Esporta
          </Button>
        </div>
      </div>

      <Card noPadding className="mb-6" data-id="element-2351" data-mp="2vkw1gol470y5">
        <div className="p-4 border-b border-slate-100 flex flex-col sm:flex-row gap-4" data-id="element-2352" data-mp="2vjt7u8weqkej">
          <div className="flex-1 relative" data-id="element-2353" data-mp="2rihje6p9s57x">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" data-id="element-2354" data-mp="2rhpv7gy059ro" />
            <input type="text" placeholder="Cerca per azione, cliente o prodotto..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-seform-orange/50 focus:border-seform-orange" data-id="element-2355" data-mp="35crz5yjagp1u" />
          </div>
          <div className="flex gap-3" data-id="element-2356" data-mp="1s1afz62y9t6">
            <Select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} options={[{
            value: 'all',
            label: 'Tutti gli stati'
          }, {
            value: 'todo',
            label: 'Da fare'
          }, {
            value: 'done',
            label: 'Completate'
          }]} className="w-40" data-id="element-2357" data-mp="1qq4bsp5wpyw" />
            <Select value={assigneeFilter} onChange={e => setAssigneeFilter(e.target.value)} options={[{
            value: 'all',
            label: 'Tutti gli assegnatari'
          }, {
            value: 'consulente',
            label: 'Consulente'
          }, {
            value: 'cliente',
            label: 'Cliente'
          }]} className="w-48" data-id="element-2358" data-mp="3151xq57o4zhr" />
          </div>
        </div>

        <ActionsTable actions={currentActions} showClient showResponsible onActionUpdate={handleActionUpdate} data-id="element-2359" data-mp="3prl4zq4bx6vd" />

        {totalPages > 1 && <div className="p-4 border-t border-slate-100 flex justify-end" data-id="element-2360" data-mp="3fwjiz35cokx0">
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={goToPage} data-id="element-2361" data-mp="3bt4zg2i7dmet" />
          </div>}
      </Card>
    </Layout>;
}